import { useTheme } from "@mui/material";
import { useCheckViewPoint, VIEW_POINT_CONFIG } from "hooks/useCheckViewPoint";
import { Col, Row } from "v2/components/base/Flex/ui";

const DiscoverLayout = ({
  Filters,
  Scrollable,
}: {
  Filters: React.ReactNode;
  Scrollable: React.ReactNode;
}) => {
  const isMobile = useCheckViewPoint(VIEW_POINT_CONFIG.MOBILE);

  return (
    <DiscoverLayoutWrapper>
      <ScrollableSection Scrollable={Scrollable}>
        <FiltersSection Filters={Filters} />
      </ScrollableSection>
    </DiscoverLayoutWrapper>
  );
};

const DiscoverLayoutWrapper = ({ children }: { children: React.ReactNode }) => {
  return (
    <Col type="ss" sx={{ position: "relative", gap: "16px" }} fullWidth fullHeight>
      {children}
    </Col>
  );
};

const FiltersSection = ({ Filters }: { Filters: React.ReactNode }) => {
  return (
    <Row type="ss" sx={{ position: "sticky", top: "0", maxWidth: "100%" }} fullWidth>
      <Row sx={{ gap: "6px", overflowX: "scroll" }} fullWidth>
        {Filters}
      </Row>
    </Row>
  );
};

const ScrollableSection = ({
  Scrollable,
  children,
}: {
  Scrollable: React.ReactNode;
  children: React.ReactNode;
}) => {
  const theme = useTheme();
  return (
    <Row fullWidth sx={{ flex: 1, height: "100%" }}>
      <Col
        type="ss"
        sx={{ position: "relative", gap: "16px", maxHeight: "100%", overflowY: "hidden" }}
        fullWidth
        fullHeight>
        {/* <Row fullWidth> */}
        {children}
        {/* </Row> */}
        {/* <Row fullWidth fullHeight> */}
        {Scrollable}
        {/* </Row> */}
        {/* <Row sx={{ height: "100px" }} /> */}
      </Col>
    </Row>
  );
};

export { DiscoverLayout };
